export default () => {
  const $btn = $('#js-spnavi-toggle'),
    $body = $('#js-spnavi-body'),
    $main = $('#js-main'),
    $navi = $('#js-sideNavi a')

  $btn.on('click', function() {
    if ($(this).hasClass('is-active')) {
      $(this).removeClass('is-active')
      $body.removeClass('is-show')
      $main.removeClass('is-hide')
    } else {
      $(this).addClass('is-active')
      $body.addClass('is-show')
      $main.addClass('is-hide')
    }
  })
  $main.add($navi).on('click', function() {
    $btn.removeClass('is-active')
    $body.removeClass('is-show')
    $main.removeClass('is-hide')
  })

  $('#app').on('touchstart', onTouchStart) //指が触れたか検知
  $('#app').on('touchmove', onTouchMove) //指が動いたか検知
  $('#app').on('touchend', onTouchEnd) //指が離れたか検知
  var direction, position

  //スワイプ開始時の横方向の座標を格納
  function onTouchStart(event) {
    position = getPosition(event)
    direction = '' //一度リセットする
  }

  //スワイプの方向（left／right）を取得
  function onTouchMove(event) {
    if (position - getPosition(event) > 70) {
      // 70px以上移動しなければスワイプと判断しない
      direction = 'left' //左と検知
    } else if (position - getPosition(event) < -70) {
      // 70px以上移動しなければスワイプと判断しない
      direction = 'right' //右と検知
    }
  }

  function onTouchEnd(event) {
    if (direction == 'left') {
      $btn.removeClass('is-active')
      $body.removeClass('is-show')
      $main.removeClass('is-hide')
    }
  }

  //横方向の座標を取得
  function getPosition(event) {
    return event.originalEvent.touches[0].pageX
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/navi.js